import React from "react";
// Resim importları
import logogenova from '../assets/images/geneva.png';
import logorodl from '../assets/images/rodl.png';
import logoch from '../assets/images/chLogo.png';
import logoahk from '../assets/images/ahk.png';
import logoGerman from '../assets/images/deGerman.png';
import logoAlpplas from '../assets/images/alpplas.png'; // Alpplas burada
import logoema from '../assets/images/ema.webp';
import logoVideojet from '../assets/images/videojet.png';
import logoEmsan from '../assets/images/emsan.png';
import logoHazera from '../assets/images/hazera.png';
import logoNis from '../assets/images/nislogo.png';

import { useTranslation } from 'react-i18next';

const Works = () => {
  const { t } = useTranslation();


  const logos = [

    { src: logogenova, alt: "Geneva ", name: "Geneva" },
    { src: logorodl, alt: "Rödl & Partner ", name: "Rödl" },
    { src: logoch, alt: "İsviçre Konsolosluğu ", name: "Swiss Consulate" },
    { src: logoahk, alt: "Alman-Türk Sanayi ve Ticaret Odası (AHK) ", name: "AHK" },
    { src: logoGerman, alt: "Alman Ticaret Odası ", name: "German Chamber" },
   
    { src: logoAlpplas, alt: "Alpplas Plastik Sanayi ", name: "Alpplas", specialStyle: true },
    
  
    { src: logoema, alt: "EMA ", name: "EMA" },
    { src: logoVideojet, alt: "Videojet ", name: "Videojet" },
    { src: logoEmsan, alt: "Emsan ", name: "Emsan" },
    { src: logoHazera, alt: "Hazera ", name: "Hazera" },
    { src: logoNis, alt: "Nis ", name: "Nis" },
  ];


  const firstRow = logos.slice(0, 6); 
  const secondRow = logos.slice(6); 

  
  const boxBaseClasses = "w-24 h-24 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-40 lg:h-40 bg-white flex items-center justify-center p-1 border border-gray-200 rounded-lg shadow-md overflow-hidden transition duration-500 ease-in-out transform hover:scale-105 hover:shadow-xl";

  return (
    <section className="py-16 md:py-24 bg-white" aria-labelledby="exampleswork">
 
      <h2 
        id="exampleswork" 
        className="text-center text-3xl md:text-4xl mb-12 font-extrabold text-red-800 tracking-tight" 
        aria-label={t('brand')}
      >
        {t('brand')}
      </h2>

      <div className="container mx-auto px-4">
       
 
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-3 md:grid-cols-6 justify-items-center mb-6"> 
          {firstRow.map((logo, index) => (
            <div
              key={`row1-${index}`}
           
              className={boxBaseClasses}
            >
              <img
                src={logo.src}
                alt={logo.alt} 
                title={logo.name} 
                

                className={`w-full h-full object-contain ${logo.specialStyle ? 'p-1' : ''}`} 
                loading="lazy"
              />
            </div>
          ))}
        </div>
        

      
        <div className="flex justify-center">
           
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-3 md:grid-cols-5 w-full max-w-5xl"> 
            {secondRow.map((logo, index) => (
                <div
                key={`row2-${index}`}
             

                className={`${boxBaseClasses} mx-auto`} 
                >
                <img
                    src={logo.src}
                    alt={logo.alt} 
                    title={logo.name}
                    className="w-full h-full object-contain"
                    loading="lazy"
                />
                </div>
            ))}
            </div>
        </div>
      </div>
      
     
    </section>
  );
};

export default Works;